"use strict";

var SoftWallet = require('./softWallet');

var HardWallet = require('./hardWallet');

var HybridWallet = require('./hybridWallet');

var LiteWallet = require('./liteWallet');

var NonWallet = require('./nonWallet');

module.exports = {
  SoftWallet: SoftWallet,
  HardWallet: HardWallet,
  HybridWallet: HybridWallet,
  LiteWallet: LiteWallet,
  NonWallet: NonWallet
};